import { PriceIntervalEnum } from "@finway-group/shared/lib/models"
import { Button, Card, Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { CardIcon } from "~Components/icons/CardIcon"
import { InfoCircleIcon } from "~Components/icons/InfoCircleIcon"
import { BillingProductCardPricesModal } from "~Components/modals/billingProductCardPrices.modal"
import { PriceLabel } from "~Components/priceLabel"
import { useModal } from "~Shared/context/modal.context"
import { useBillingCardInfo } from "~Shared/queries/billing.queries"

interface BillingSettingsCardPricesCardProps {
    subscriptionInterval: PriceIntervalEnum
}

export const BillingSettingsCardPricesCard = ({ subscriptionInterval }: BillingSettingsCardPricesCardProps) => {
    const { t } = useTranslation()
    const { showModal } = useModal()
    const { data: billingCardInfo, isFetching } = useBillingCardInfo({})

    const handleOnShowCardPrices = () =>
        showModal(BillingProductCardPricesModal, false, {
            isShowing: true,
        })

    if (isFetching || !billingCardInfo) {
        return null
    }

    return (
        <Card>
            <Row gutter={[16, 16]}>
                <Col flex={1} className="flex items-center text-lg text-primary space-x-10">
                    <div>
                        <CardIcon />
                    </div>
                    <div>
                        <p>
                            ({billingCardInfo?.cardCount}) {t("label:payment_settings.physical_cards")}
                        </p>
                        <p>
                            <span>
                                <PriceLabel value={billingCardInfo.cardPriceTotal / 100} currency={billingCardInfo.currency} />{" "}
                                {t(`label:payment_settings.per_card_interval.${PriceIntervalEnum[subscriptionInterval].toLowerCase()}`)}
                            </span>
                            <span className="finway-gray-text text-sm">
                                {" "}
                                / <PriceLabel value={billingCardInfo.cardPricePerUnit / 100} currency={billingCardInfo.currency} /> {t("label:payment_settings.per_card")}
                            </span>
                        </p>
                    </div>
                </Col>
                <Col flex={1} className="flex justify-end items-center text-xl font-semibold text-primary">
                    <Button loading={isFetching} icon={<InfoCircleIcon />} className="ant-btn btn-highlight-gray-active" onClick={handleOnShowCardPrices}>
                        {t("action:payment_settings.card_prices")}
                    </Button>
                </Col>
            </Row>
        </Card>
    )
}
